module.exports = __webpack_public_path__ + "img/OAS_HandPaintedRunicSword_Green_Pref.00f5d237.png";